import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Emails from '@/pages/emails';
import { ROUTES } from '@/config/routes';

export default function Routes() {
  return (
    <Switch>
      <Route exact path={ROUTES.home} component={Emails} />
    </Switch>
  );
}
